<template>
  <details class="node-tree">
    <summary v-on:click="activate({filter: name, value: node.ID})">{{ node.title }}{{ counts[`${name}.${node.ID}`] && ` (${counts[`${name}.${node.ID}`].good})` }}</summary>
    <p class="text-warning mb-1" v-if="counts[`${name}.${node.ID}`] && counts[`${name}.${node.ID}`].bad">
      <em>{{ counts[`${name}.${node.ID}`].bad }} missing lat/lng</small></em>
    </p>
    <div v-if="node.options && node.options.length">
      <node v-on:activate="activate($event)" v-for="child in node.options" :node="child" :name="name" key="child.ID" :counts="counts"></node>
    </div>
  </details>
</template>

<script>
export default {
  name: "node",
  props: {
    name: String,
    node: Object,
    counts: Object,
  },
  methods: {
    activate(params) {
      this.$emit('activate', params);
    }
  }
};
</script>
